import { observer } from 'mobx-react';
import React, { useCallback, useEffect } from 'react';
import { menuManagementNavigation } from '../../constants/menuManagement';
import ModifiersList from './containers/ModifiersList/ModifiersList';
import modifiersStore from './store/modifiersStore';
import { AVAILABILITY_OPTIONS } from 'src/constants/main';
import { SCREENS } from 'src/constants/screens';
import integrationsStore from 'src/mobx/integrationStore';
import { getLastArrayItem, isDisabledByPos } from 'src/utils/helpers';
import { IPickerOption } from 'src/view/components/Controls/Pickers/Picker/types/index';
import MenuManagTabHeader from 'src/view/containers/Headers/containers/MenuManagTabHeader/MenuManagTabHeader';
import ScreenHeader from 'src/view/containers/Headers/containers/ScreenHeader/ScreenHeader';

const ModifiersScreen: React.FC = observer((): JSX.Element => {
  useEffect(() => {
    modifiersStore.unMount();

    return () => modifiersStore.unMount();
  }, []);

  const selectAvailability = useCallback((options: IPickerOption[]) => {
    modifiersStore.setFilters({
      availability: getLastArrayItem<IPickerOption>(options)?.value as AVAILABILITY_OPTIONS,
    });
  }, []);

  const setSearch = useCallback((search: string) => {
    modifiersStore.setFilters({ search });
  }, []);

  return (
    <>
      <ScreenHeader title="txt_menu" options={menuManagementNavigation()} />
      <MenuManagTabHeader
        createPath={SCREENS.MODIFIERS_CREATE()}
        availability={modifiersStore.filters.availability}
        search={modifiersStore.filters.search}
        loading={modifiersStore.isLoading}
        foundItemsInSystem={modifiersStore.foundModifiersInSystem || Boolean(modifiersStore.pagination.data.length)}
        createButtonTitle="create_modifier"
        includeDeleteOption
        posRestrictionOnCreate={isDisabledByPos(integrationsStore.posRestrictions?.modifierCreate)}
        selectAvailability={selectAvailability}
        setSearch={setSearch}
        includeAvailabilityPicker
      />
      <ModifiersList />
    </>
  );
});

export default ModifiersScreen;
